import { GetSolutionInstances } from '@/connection/integrations/integrations';
import { serializeError } from '@/store/utils/serialize-error';
import { ChannelSettingsReducerCreator } from '../types';

const fetchSolutionInstancesReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async ({ userId }: { userId: string }, { rejectWithValue }) => {
      try {
        const instances = await GetSolutionInstances(userId);
        return instances;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        state.solutionInstances = action.payload;
      },
    }
  );
};

export default fetchSolutionInstancesReducer;
